import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const AdventsCalendar = lazy(
  () =>
    import('./AdventsCalendar.eager').then(mod => ({
      default: mod.AdventsCalendar,
    })),
  {
    fallback: <LoadingPageSpinner />,
  },
);
